export default "__VITE_ASSET__DbxbdHRT__"